export const environment = {
    production: false,
    apiUrl: 'https://staging-api-admin-portal.vlinkgroup.net/api'
};
